import { type FC } from 'react';
import { type NavbarTab } from './types';
import { Tab } from './components';

interface TabsProps {
    tabs: NavbarTab[];
    onClose?: VoidFunction;
    compact?: boolean;
}

export const Tabs: FC<TabsProps> = ({ tabs, onClose, compact = false }) => {
    return tabs.map((tab) => {
        return (
            <Tab
                key={tab.to}
                tab={tab}
                onClose={onClose}
                compact={compact}
            />
        );
    });
};
